import React, { Suspense, useContext } from "react";
import { Route as RouterRoute, Redirect, useLocation } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

const CustomRoute = ({ component: Component, isPrivate = false, componentProps = {}, ...rest }) => {
  const { isAuth, loading } = useContext(AuthContext);
  const location = useLocation();

  // Verificação PRIORITÁRIA para rotas de landing page (/l/)
  // Esta verificação deve vir ANTES de qualquer lógica de autenticação
  const currentPath = location.pathname || rest.path;
  if (currentPath && currentPath.startsWith('/l/')) {
    return (
      <Suspense fallback={<BackdropLoading />}>
        <RouterRoute
          {...rest}
          render={props => <Component {...props} {...componentProps} />}
        />
      </Suspense>
    );
  }

  // Loading state - mas só se realmente estiver carregando
  if (loading === true) {
    return <BackdropLoading />;
  }

  // Lógica de redirecionamento para outras rotas (não landing pages)
  if (!isAuth && isPrivate) {
    return (
      <Redirect to={{ pathname: "/login", state: { from: location } }} />
    );
  }

  if (isAuth && !isPrivate) {
    // Evita redirecionamento infinito para a página inicial
    const isPublicRoute = ["/login", "/signup"].includes(currentPath);
    if (isPublicRoute) {
      return (
        <Redirect to={{ pathname: "/", state: { from: location } }} />
      );
    }
  }

  return (
    <Suspense fallback={<BackdropLoading />}>
      <RouterRoute
        {...rest}
        render={props => <Component {...props} {...componentProps} />}
      />
    </Suspense>
  );
};

export default CustomRoute;